import ViewChannelTab from "./ViewChannelTab";
export default ViewChannelTab;
